import pub from './../public'
const type = pub.getLang();

const language = {
  "zh-hk": {
    propertyListings: "刊登樓盤價格",
    listingNormal: "標準盤",
    validitySale: ["一般放盤：售盤為期", "日，",],
    validityRent: ["租盤為期", '日'],
    StarSale:["有較高曝光機會：售盤為期", "日，"],
    StarRent:["租盤為期", '日'],
    listingGoldenTop: "精選盤",
    priorityDisplay: ["更有效曝光；售盤/租盤為期", "日"],
    agencytxt: ["我們另設地產代理套餐，如想了解更多，", "歡迎與我們聯絡"],
    sale: '售盤',
    rent: '租盤',
    Star: '星級盤',
    remark: '放盤列表排序說明'
  },
  "zh-cn": {
    propertyListings: "刊登楼盘价格",
    listingNormal: "标准盘",
    validitySale: ["一般放盘；售盘为期", "日，",],
    validityRent: ["租盘为期", '日'],
    StarSale:["有较高曝光机会：售盘为期", "日，"],
    StarRent:["租盘为期", '日'],
    listingGoldenTop: "精选盘",
    priorityDisplay: ["更有效曝光； 售盘/租盘为期", "日"],
    agencytxt: ["我们另设地产代理套餐，如想了解更多，", "欢迎与我们联络"],
    sale: '售盘',
    rent: '租盘',
    Star: '星级盘',
    remark: '放盘列表排序说明'

  },
  "en-us": {
    propertyListings: "Property Listing Fee",
    listingNormal: "Standard",
    validitySale: ['General Listing: ', ' days (for sale) or '],
    validityRent: ["", ' days (for rent)'],
    StarSale:["Listing with better exposure：", 'days (for sale) or '],
    StarRent:["", ' days (for rent)'],
    listingGoldenTop: "Featured",
    priorityDisplay: ['Listing with better exposure: ', ' days (for sale or rent)'],
    agencytxt: ["If you would like to know more about Property Agent Package,", " please contact us"],
    sale: 'Sale',
    rent: 'Rent',
    Star: 'Premium Listing',
    remark: 'Ranking of Listings'

  }
}

export default language[type]